import React from 'react';
import { useCreateList } from './useCreateList';
import CreateForm from './components/create-form/CreateForm';

const CreateList = () => {
  const { show } = useCreateList();
  return show ? <CreateForm /> : null;
};
export default CreateList;
